import {
    Box,
    Stack
} from '@mui/material';
import { formatPrice } from '../helpers/misc';

const InvoiceTableFooter = ({ invoices }) => {
    const sumTotal = (type) => {
        let amounts = invoices.map((invoice) => invoice[type]);
        amounts = amounts.filter((amount) => typeof amount === 'number');

        let total = 0;
        for (const amount of amounts) {
            total += amount;
        }
        return formatPrice(total);
    }
    
    return (        
        <Stack
            direction='row'
            alignItems='center'
            justifyContent='flex-end'
            spacing={1}
            marginTop={1}
        >
            <Box>
                <b>SALES TAX: </b>
                {sumTotal('sales_tax_amount')}
            </Box>
            <Box>
                <b>SUB TOTAL: </b>
                {sumTotal('sub_total_amount')}
            </Box>
        </Stack>
    )
}

export default InvoiceTableFooter;